import { Vue, Component, Prop } from 'vue-property-decorator'
import { Location } from 'vue-router'
import DiseaseSection from '~/types/api/disease/DiseaseSection'
import DiseaseSectionIconList from '~/components/block/DiseaseSectionIconList'

@Component
export default class MainDiseaseBlock extends Vue {
  @Prop({ required: true, type: Array })
  readonly items!: DiseaseSection[]

  @Prop({ type: String, default: 'Справочник заболеваний' })
  readonly title!: string

  @Prop({ type: String, default: 'Смотреть все' })
  readonly linkTitle!: string

  @Prop({ default: '/' })
  readonly location!: Location

  @Prop({ type: Boolean, default: true })
  readonly isShowButton!: boolean

  sectionsToShow: number = 12;

  get topSections () {
    return this.items.filter(e => e.icon).slice(0, this.sectionsToShow)
  }

  renderButtonLink () {
    if (this.isShowButton) {
      return (
        <div>
          <nuxt-link class="product-slides__link" to={this.location}>
            {this.linkTitle}
          </nuxt-link>
          <nuxt-link class="product-slides__link-mobile" to={this.location}>
            Все
          </nuxt-link>
        </div>
      )
    }
  }

  render () {
    return (
      <div class="disease-section-icon-list">
        <div class="product-slides__top">
          <h2 class="product-slides__header">
            {this.title}
          </h2>
          {this.renderButtonLink()}
        </div>
        <DiseaseSectionIconList {...{
          props: {
            items: this.topSections
          }
        }} />
      </div>
    )
  }
}
